import Icon from '../components/Icon.vue'

Icon.register({"map-pin":{"width":1024,"height":1792,"paths":[{"d":"M512 1088q66 0 128-15v655q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-655q62 15 128 15zM512 0q212 0 362 150t150 362-150 362-362 150-362-150-150-362 150-362 362-150zM512 224q14 0 23-9t9-23-9-23-23-9q-146 0-249 103t-103 249q0 14 9 23t23 9 23-9 9-23q0-119 84.5-203.5t203.5-84.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-pin.js
// module id = 1663
// module chunks = 0